import {
  AccessTime,
  CalendarMonth,
  EventAvailable,
  HelpOutline,
  MoreTime,
  Settings,
  Timer,
  ViewKanban,
  WarningAmberRounded,
} from '@mui/icons-material';

import { routerUrls } from '@/configs/routes/routerUrls';
import { trackerUrls } from '@/tracker';

export type NavLink = {
  text: string;
  icon: React.ReactNode;
  link: string;
  external?: boolean;
};

export const links: NavLink[] = [
  { text: 'Таблица', icon: <AccessTime />, link: routerUrls.root },
  { text: 'Календарь', icon: <CalendarMonth />, link: routerUrls.calendar },
  { text: 'Секундомеры', icon: <Timer />, link: routerUrls.stopwatches },
  { text: 'Настройки', icon: <Settings />, link: routerUrls.settings },
  { text: 'FAQ', icon: <HelpOutline />, link: '' },
];

/** Внизу, рядом с «Новым учётом»: трекер в разработке, как и собственный учёт */
export const trackerLink: NavLink = {
  text: 'Трекер',
  icon: <ViewKanban />,
  link: trackerUrls.root,
};

/** Собственный учёт времени (API v2): раскрываемая группа внизу, пока идёт переход */
export const v2Group = {
  text: 'Новый учёт',
  icon: <MoreTime />,
  links: [
    { text: 'Таблица', icon: <AccessTime />, link: routerUrls.v2.table },
    { text: 'Календарь', icon: <EventAvailable />, link: routerUrls.v2.calendar },
  ] satisfies NavLink[],
};

export const BUG_REPORT_URL = import.meta.env.VITE_BUG_REPORT_URL || '';

export const bottomLinks: NavLink[] = [
  { text: 'Баг-репорт', icon: <WarningAmberRounded />, link: BUG_REPORT_URL, external: true },
];
